import { computed, defineComponent, useCssModule } from '@nuxtjs/composition-api';
import { ABBR_TO_DIGITS_PRICE_MAP } from './';
import { getArticleInfo } from '~/utils';
export default defineComponent({
    name: 'CardFranchise',
    inheritAttrs: false,
    props: {
        data: {
            required: true,
            type: Object,
        },
        size: {
            default: () => ({
                height: 1,
                width: 1,
            }),
            type: Object,
        },
    },
    setup(props, { root }) {
        /**
         * Composables.
         */
        const css = useCssModule();
        /**
         * Article
         */
        const article = computed(() => ({
            ...props.data,
            ...getArticleInfo.call(root, props.data),
        }));
        /**
         * Entries
         */
        const entries = computed(() => {
            const { activity_category: entries = [], rubrics } = article.value || {};
            if (!entries.length) {
                return rubrics || [];
            }
            return (entries?.map(({ id, name: title }) => ({
                title,
                to: `/franchises/catalog?activity_category=${id}`,
            })) || []);
        });
        /**
         * Franchise income
         */
        const franchiseIncome = computed(() => {
            const { monthly_income: income } = article.value || {};
            if (!income) {
                return null;
            }
            const newWords = [];
            const words = income?.split(' ') || [];
            for (const word of words) {
                newWords.push(ABBR_TO_DIGITS_PRICE_MAP[word] || word);
            }
            return newWords.join(' ');
        });
        /**
         * Franchise label
         */
        const franchiseLabel = computed(() => {
            const { subscriptions = [] } = article.value || {};
            if (!subscriptions?.length) {
                return null;
            }
            const { tariff = {} } = subscriptions.find((item) => item.tariff) || {};
            return tariff?.profitable;
        });
        return {
            article,
            css,
            entries,
            franchiseIncome,
            franchiseLabel,
        };
    },
});
